import { map } from 'ramda';

const readFileText = async file =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.addEventListener('load', () => {
            try {
                resolve(reader.result);
            } catch (e) {
                reject(e);
            }
        });
        reader.addEventListener('error', reject);
        reader.readAsText(file);
    });

/*
 * Call reader to read one or more files uploaded by the user
 * Impure: uses the browser's internal upload mechanism
 * @sig readUploadedFiles :: Event -> Promise String|Error
 */
const readUploadedFiles = async event => {
    const inParallel = map(readFileText, event.target.files);
    event.target.value = null; // make sure the onInput event will be called next time if the selection is the same
    return Promise.all(inParallel);
};

export { readUploadedFiles };
